import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

const PaymentDetails = () => {
  const {state} = useLocation();

  const [iState,setUpdate] = useState({});

  useEffect(()=>{
    setUpdate(state)
  },[state])


  return (
    <>
     <div className="WrapperArea">
  <div className="WrapperBox">
    <div className="OrderDetails">
      <h5>Payment Details</h5>
      <article>
        <aside>
          <p>
            <label>Transaction ID</label>
            <span>{iState?.transactionId}</span>
          </p>
          <p>
            <label>Transaction Date &amp; Time</label>
            <span>{iState?.createdAt?.slice(0,10)} &amp; {iState?.createdAt?.slice(11,16)}</span>
          </p>
          <p>
            <label>Booking ID</label>
            <span>{iState?.orderId}</span>
          </p>
          <p>
            <label>Customer ID</label>
            <span>{iState?.customerId}</span> 
          </p>
        </aside>
        <aside>
          <p>
            <label>Customer Name</label>
            <span>{iState?.customerName}</span> 
          </p>
          <p>
            <label>Paid Amount (in Rs.)</label>
            <span>{iState?.paidAmount}</span>
          </p>
          <p>
            <label>Remaining amount (in Rs.)</label>
            <span>{iState?.remainingAmount}</span>
          </p>
          <p>
            <label>Total Amount</label>
            <span>Rs. {iState?.totalAmount}</span>
          </p>
          <p>
            <label>Payment Status</label>
            <span>{iState?.paymentStatus}</span>
          </p>
        </aside>
      </article>
    </div>
  </div>
</div> 
    </>
  )
}

export default PaymentDetails
